import script from "./FormReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormReports.vue?vue&type=script&setup=true&lang=ts"

import "./FormReports.vue?vue&type=style&index=0&id=5172f7d9&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5172f7d9"]])

export default __exports__